import { message, PageHeader, Select, Space, Tag } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { SelectItem, TableItemDinamico } from "../../../Components/Items";
import round4Decimals from "../../../Components/round4Decimals";
import DesgloseUbicacionesInsumo from "./Components/DesgloseUbicacionesInsumo";
import DesgloseApartadoInsumo from "./Components/DesgloseApartadoInsumo";

const { Option } = Select;

class Inventario extends Component {
  tableRef = null;
  state = {
    loading: false,
    objetoProyectos: [],
    todasProyectos: [],
    todasInventario: [],
    proyecto: undefined,
    proyectoId: undefined,
    filtrosFamilias: [],
    filtrosTipoInsumos: [],
    valor: 5,
    totalRecords: 0,
  };

  async consultarInventario(params) {
    this.setState({ loading: true });

    const payload = {
      empresaId: this.props.empresaId,
      ...params,
      limit: params.pageSize,
    };

    if (this.state.proyectoId) {
      payload.proyectoId = this.state.proyectoId;
    }

    await axios
      .post("inventarios/selectInventario", payload, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.status === 404 || !res.data) {
          this.setState({ todasInsumos: [], totalRecords: 0, loading: false });
        } else {
          this.setState({
            todasInsumos: res.data.data || res.data,
            totalRecords: res.data.totalRecords || (res.data.length ? res.data.length : 0),
          });
        }
      })
      .catch((error) => {
        console.error("Error al consultar inventario:", error);
        this.setState({ todasInsumos: [], loading: false });
      });
    this.setState({ loading: false });
  }
  async componentDidMount() {
    this.setState({ loading: true });

    const [resProyectos, resFiltros] = await Promise.all([
      axios.post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      ),
      axios.post(
        "inventarios/selectDatosFiltrados",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
    ]);

    if (resProyectos.data.status !== 404) {
      this.setState({
        todasProyectos: resProyectos.data,
        objetoProyectos: resProyectos.data.map((value) => (
          <Option value={value._id} key={value._id}>
            {value.nombre}
          </Option>
        )),
      });
    }

    if (resFiltros.data.success === 2) {
      this.setState({
        filtrosFamilias: resFiltros.data.familias.map(v => ({
          text: v.nombre,
          value: v._id.toString()
        })),
        filtrosTipoInsumos: [
          { text: "Sin Tipo Insumo", value: 1 },
          ...resFiltros.data.tiposDeInsumos.map(v => ({
            text: v.nombre,
            value: v._id.toString()
          }))
        ]
      });
    } else {
      message.error('Hubo un error y no se cargaron los filtros');
    }

    if (this.props.location?.state?.proyectoId) {
      this.onChangeProyecto(this.props.location.state.proyectoId);
    }
  }

  onChangeProyecto(value) {
    if (value === 0) {
      this.setState({ loading: true, proyecto: undefined, proyectoId: undefined }, () => {
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ proyectoId: undefined });
        }
      });
    } else {
      const proyecto = this.state.todasProyectos.find(valueState => valueState._id.toString() === value.toString());
      this.setState({ proyecto: proyecto.nombre, proyectoId: proyecto._id }, () => {
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ proyectoId: proyecto._id });
        }
      });
    }
  }
  render() {
    const columns = [
      {
        title: <span style={{ whiteSpace: "normal", wordBreak: "break-word", display: "block", lineHeight: 1.3 }}>Clave / Código de Barras</span>,
        key: "claveCodigoBarras",
        width: "13%",
        render: (record) => (
          <div>
            <div style={{ fontWeight: 400, color: "#6a6a6a" }}>{record.clave}</div>
            <div style={{ color: "#000000", fontSize: "12px", fontWeight: 500 }}>{record.codigoBarras}</div>
          </div>
        ),
      },

      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        width: "30%",
      },
      {
        title: "Familia",
        dataIndex: "familiaNombre",
        key: "familiaNombre",
        filters: this.state.filtrosFamilias,
        width: "10%",
      },
      {
        title: "Tipo Insumo",
        dataIndex: "tipoInsumoNombre",
        key: "tipoInsumoNombre",
        filters: this.state.filtrosTipoInsumos,
        width: "10%",
      },
      {
        title: "Marca",
        dataIndex: "marcaNombre",
        key: "marcaNombre",
        width: "10%",
        buscar: "marcaNombre",
      },
      {
        title: "Código Proveedor",
        dataIndex: "codigoProveedor",
        key: "codigoProveedor",
        width: "10%",
      },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        key: "cantidad",
        sorter: (a, b) => {
          if (a.cantidad < b.cantidad) {
            return -1;
          }
          if (a.cantidad > b.cantidad) {
            return 1;
          }
          return 0;
        },
        width: "20%",
        render: (value) => round4Decimals(value).toFixed(4),
      },
      {
        title: "Unidad",
        dataIndex: "unidad",
        key: "unidad",
        render: (value) => value.nombre,
        width: "10%",
      },
      // {
      //   title: "Costo P.",
      //   dataIndex: "costoPromedio",
      //   key: "costoPromedio",
      //   sorter: (a, b) => {
      //     if (a.costoPromedio < b.costoPromedio) {
      //       return -1;
      //     }
      //     if (a.costoPromedio > b.costoPromedio) {
      //       return 1;
      //     }
      //     return 0;
      //   },
      //   width: "20%",
      //   render: (value) => dineroDisabledMask(value || 0),
      // },
      {
        title: "Estado",
        dataIndex: "estado",
        responsive: ["md"],
        key: "estado",
        render: (value, record, index) => {
          if (value === 2) {
            return (
              <Tag key={index.toString()} color="blue" className="square-tag">
                Apartado
              </Tag>
            )
          }
          if (value === 3) {
            return (
              <Tag key={index.toString()} color="orange" className="square-tag">
                Consignación
              </Tag>
            )
          }
        },
        width: "12%",
      },
    ];
    return (
      <>
        <PageHeader
          title={this.state.proyecto ? "Inventario: " + this.state.proyecto : "Inventario: Todos"}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Space style={{ width: "100%" }}>
              <SelectItem
                placeholder="Proyecto"
                width={200}
                onChange={this.onChangeProyecto.bind(this)}
                defaultValue={0}
              >
                <Option value={0}>Todos</Option>
                {this.state.objetoProyectos}
              </SelectItem>
            </Space>
          }
        />
        <TableItemDinamico
          ref={(ref) => this.tableRef = ref}
          onRef={(ref) => this.tableRef = ref}
          onFetchData={this.consultarInventario.bind(this)}
          totalRecords={this.state.totalRecords}
          dataSource={this.state.todasInsumos || []}
          loading={this.state.loading}

          columns={columns}
          size="small"
          pagination={false}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
          valorTextoDefault={""}
          filterStorageKey={"inventarioFiltrosTabla" + this.props.empresaId}
          expandable={
            this.state.proyectoId
              ? {
                  // Sin proyecto seleccionado el backend agrupa por insumo y no devuelve
                  // estado, por eso el desglose de apartado solo aplica aqui.
                  rowExpandable: (record) => this.props.moduloWms || record.estado === 2,
                  expandedRowRender: (record) => (
                    <>
                      {this.props.moduloWms && (
                        <DesgloseUbicacionesInsumo
                          empresaId={this.props.empresaId}
                          headersToken={this.props.headersToken}
                          proyectoId={this.state.proyectoId}
                          insumoId={record.insumoId || record._id}
                          insumoNombre={record.descripcion}
                        />
                      )}
                      {record.estado === 2 && (
                        <DesgloseApartadoInsumo
                          empresaId={this.props.empresaId}
                          headersToken={this.props.headersToken}
                          proyectoId={this.state.proyectoId}
                          insumoId={record.insumoId || record._id}
                          history={this.props.history}
                        />
                      )}
                    </>
                  ),
                }
              : undefined
          }
          onRow={(record, rowIndex) => {
            return {
              onDoubleClick: (event) => {
                this.props.history.push("/panel/inventarioInsumo", {
                  id: record.insumoId || record._id,
                  proyectoId: this.state.proyectoId
                });
              },
            };
          }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    moduloWms: state.empresa.moduloWms,
  };
};

export default connect(mapStateToProps)(Inventario);
